import { MapElementFactory } from "vue2-google-maps";

export default MapElementFactory({
  name: "directionsRenderer",

  ctr() {
    return window.google.maps.DirectionsRenderer;
  },

  events: [],

  mappedProps: {},

  props: {
    origin: { type: Object },
    destination: { type: Object },
    travelMode: { type: String }
  },

  afterCreate(directionsRenderer) {
    let directionsService = new window.google.maps.DirectionsService();

    let { origin, destination, travelMode } = this;
    this.generateToast("Loading direction ...", "success");
    
    directionsService.route(
      {
        origin,
        destination,
        travelMode
      },
      (response, status) => {
        if (status == "OK") {
          directionsRenderer.setDirections(response);
          this.generateToast("Direction loaded", "success");
        } else {
          return;
        }
      }
    );

    
    this.$watch(
      () => [this.origin, this.destination, this.travelMode],
      () => {
        let { origin, destination, travelMode } = this;
        this.generateToast("Loading direction ...", "success");
        
        directionsService.route(
          {
            origin,
            destination,
            travelMode
          },
          (response, status) => {
            if (status == "OK") {
              directionsRenderer.setDirections(response);
              this.generateToast("Direction loaded", "success");
            } else {
              return;
            }
          }
        );
    
      }
    );
  }
});
